'use strict';

const Backbone = require('backbone');
const _ = require('underscore');

//Base component, most other views are inherider from it
//can render itself and control the child components
module.exports = Backbone.View.extend(_.extend({}, Backbone.Events, {

    initialize: function (options = {}) {
        this.options = options;

        // storage for child views
        this.views = {};

        // storage for sections
        this.sections = [];

        this.$content = null;

        this.parent = this.options.parent;
    },

    sectionShown: function (viewName, $el) {
        if (!viewName) {
            return;
        }

        // we need to check if current view is not in this instance, but deeper in childViews
        _.each(this.views, (childViewInstance) => {
            if ('sectionShown' in childViewInstance) {
                childViewInstance.sectionShown(viewName, $el);
            }
        });

        const view = this.getView(viewName);

        if (!view) {
            return;
        }

        if ('activateSectionShown' in view) {
            // console.log('activate view', view);
            view.activateSectionShown($el);
        }
    },

    isRendered: function () {
        return !!this.$el.length;
    },

    $parent: function () {
        return this.parent ? this.parent.$content : null;
    },

    attach: function () {
        const $parent = this.$parent();

        if ($parent) {
            $parent.append(this.$el);
        }
    },

    viewsRegistration: function (viewsToRegister = {}) {
        // console.log('viewsRegister', viewsToRegister);
        _.each(viewsToRegister, (params, viewName) => {
            // console.log('view', params, viewName);
            this.$(params.selector).each((index, view) => {
                $(view).attr('data-view', viewName);

                const data = {
                    el: view
                };

                const viewIndex = index ? `-${index}` : '';
                this.registerView(`${viewName}${viewIndex}`, params.viewConstructor, data);
            });
        });

        // console.log(this.views);
    },

    // Method to store subview in views storage object.
    // All views should be created using this method.
    registerView: function (viewName, viewConstructor, viewOptions) {
        if (!viewConstructor) {
            return;
        }

        const view = new viewConstructor(viewOptions);
        view.parent = this;
        this.views[viewName] = view;

        return view;
    },

    addView: function (view) {
        this.views.push(view);
    },

    getView: function (viewName) {
        return this.views[viewName];
    },

    destroyView: function (viewName) {
        this.views[viewName].destroy();
        delete this.views[viewName];
    }
}));
